/**
 * Determines if a username is an email address
 */
export function isEmailAddress (username: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(username)
}

/**
 * Determines if a username is a phone number (E.164 format)
 */
export function isPhoneNumber (username: string): boolean {
  // E.164 format: +[country code][national number]
  // Must start with +, followed by 7-15 digits total
  // Country code can be 1-3 digits, national number fills the rest
  const phoneRegex = /^\+\d{7,15}$/
  return phoneRegex.test(username)
}
